import React, { useState, useEffect, useContext } from 'react'
import { useAuthAPI } from '../hooks/api.hooks'
import ContentCarousel from '../components/ContentCarousel'
import getConfig from 'next/config'
import Context from '../context'
const { publicRuntimeConfig } = getConfig()

const ContentGroup = ({ position = '' }) => {
  const { state } = useContext(Context)
  const [content, setContent] = useState([])
  const [title, setTitle] = useState('')
  const [layoutPosition, setLayoutPosition] = useState('')
  const authAPICall = useAuthAPI()
  const PRODUCT_CARD = 'product-card'

  const assignProductSKUProps = async (productCards) => {
    const productSkus = productCards
      .filter((content) => content.type === PRODUCT_CARD)
      .map((x) => x.sku)
      .join(',')

    authAPICall(
      'productinfo',
      'products',
      'GET',
      {
        popkey: publicRuntimeConfig.POP_KEY,
        store: state.cart.store?.storenumber || publicRuntimeConfig.DEFAULT_STORE,
        skus: productSkus
      },
      {},
      { deviceid: state.deviceId || '' }
    ).then((data) => {
      for (const productCard of data) {
        const returnItem = productCards.filter((x) => +x.sku === +productCard.sku)
        if (returnItem.length > 0) {
          returnItem[0].upc = productCard.upc
          returnItem[0].is_sellable = productCard.is_sellable
          returnItem[0].avg_rating = productCard.avg_rating
          returnItem[0].rating_count = productCard.rating_count
          returnItem[0].image_urls = productCard.image_urls
          returnItem[0].product_name = productCard.product_name
          returnItem[0].slug = productCard.slug
          returnItem[0].in_store_only = `${productCard.in_store_only}`
          returnItem[0].digital_product_name = (
            productCard.digital_product_name || productCard.product_name
          ).toLowerCase()
          returnItem[0].inventory = productCard.qtyOnHand
          returnItem[0].in_stock = productCard.qtyOnHand > 0
          returnItem[0].price = productCard.price
          returnItem[0].discount_price = productCard.discount_price
        }
      }

      setContent(productCards)
    })
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && window.adobe && window.adobe.target) {
      window.adobe.target.getOffer({
        mbox: 'popshelf-web-mbox',
        params: {
          mbox3rdPartyId: `${state.user.UID}`
        },
        success: (offer) => {
          const carouselContent = []
          const LAYOUT_POSITION = 'layout-position'
          if (offer[0] && offer[0].content[0] && offer[0].content[0].template && offer[0].content[0].template.length) {
            setTitle(offer[0].content[0].title)
            setLayoutPosition(
              offer[0].content[0][LAYOUT_POSITION] ? offer[0].content[0][LAYOUT_POSITION] : 'bottom'
            )
            offer[0].content[0].template.forEach((contentGroup) => {
              if (contentGroup.type === PRODUCT_CARD) {
                carouselContent.push({
                  type: contentGroup.type,
                  sku: contentGroup.sku,
                  date_reference: contentGroup.date_reference,
                  campaign_name: contentGroup.campaign_name
                })
              } else {
                carouselContent.push({
                  title: contentGroup.title,
                  type: 'content-block',
                  image_url: `${publicRuntimeConfig.DG_DAM_URL}/${contentGroup.fileReference}`,
                  link_url: contentGroup.link,
                  subtitle: contentGroup.sub,
                  alt: contentGroup.alt,
                  date_reference: contentGroup.date_reference,
                  campaign_name: contentGroup.campaign_name
                })
              }
            })
            if (!position || position === (offer[0].content[0][LAYOUT_POSITION] ? offer[0].content[0][LAYOUT_POSITION] : 'bottom')) {
              if (carouselContent.some((card) => card.type === PRODUCT_CARD)) {
                assignProductSKUProps(carouselContent)
              } else {
                setContent([...carouselContent])
              }
            }
          }
        },
        error: (status, error) => {
          console.log('MBOX Error: ', status, error)
        }
      })
    }
  }, [state.cart.store, state.isAdobeLoaded])

  return (
    content.length > 0 &&
    (!position || position === layoutPosition) && (
      <div id={title} className="content-group">
        <div>
          <div className="content-group__header">
            <h2>{title}</h2>
          </div>
          <ContentCarousel data={content} />
        </div>
      </div>
    )
  )
}

export default ContentGroup
